import ColumnTypes from '@/utils/ColumnTypes';

function getColums(that) {
	let arr = [
		{
			key: 'shopDetails',
			label: '商品信息',
			type: ColumnTypes.MixinCell,
			fixed: 'left',
			minWidth: '350',
			showProductType: true,
			commissionType: true,
			isShow: true,
		},
		{
			key: 'sku_list',
			label: '规格',
			type: () => import('./tableCells/skuListCell.vue'),
			helpNum: 1,
			helpDesc1: '商品未获取规格，可点“同步指定商品"、"快速申样"、"推广商品"、"编辑商品机制"操作来获取。',
			minWidth: '150',
			showProductType: true,
			isShow: true,
		},
		{
			key: 'tag_arr',
			label: '商品标签',
			type: ColumnTypes.goodsTagCell,
			minWidth: '150',
			showProductType: true,
			isShow: true,
			auth: 'system:shopLibray:addTag',
		},
		{
			key: 'contact_user_type_desc',
			label: '推广者信息',
			type: ColumnTypes.TextCell,
			minWidth: '130',
			isShow: that.$isKs(that.platformId),
		},
		{
			key: 'sale_price',
			label: '现售价',
			type: ColumnTypes.TextCell,
			minWidth: '100',
			isShow: true,
		},
		{
			key: 'live_price',
			label: '直播价',
			type: ColumnTypes.TextCell,
			minWidth: '100',
			isShow: true,
		},
		{
			key: 'normal_commission_rate',
			label: '普通佣金率',
			type: ColumnTypes.TextCell,
			sortable: 'normal_commission_rate',
			minWidth: '130',
			isShow: !that.$isKs(that.platformId),
			transform: row => {
				return {
					...row,
					normal_commission_rate: row.normal_commission_rate == -1 ? '-' : `${row.normal_commission_rate}%`,
				};
			},
		},
		// 抖音平台增加投放期佣金率展示
		{
			key: 'commission_rate',
			label: '佣金率',
			type: () => import('./tableCells/adCommissionRateCell.vue'),
			minWidth: '100',
			isShow: true,
			sortable: 'commission_rate',
		},
		{
			key: 'service_rate',
			label: '服务费率',
			type: () => import('./tableCells/serviceRateCell.vue'),
			minWidth: '130',
			isShow: that.$auth.hasPermi('system:goods-ServiceRate'),
			sortable: 'service_rate',
		},
		{
			key: 'sales',
			label: '30天销量',
			type: ColumnTypes.TextCell,
			minWidth: '100',
			isShow: that.$isKs(that.platformId),
		},
		{
			key: 'sales',
			label: '30天销量',
			type: ColumnTypes.TextCell,
			minWidth: '100',
			isShow: that.$isPlatOr(that.platformId, ['Dy', 'Sp']),
		},
		{
			key: '',
			label: '本地素材',
			type: () => import('./tableCells/materLinkCell.vue'),
			minWidth: '100',
			isShow: that.$auth.hasPermi('system:shopLibray:batch-add-material'),
		},
		{
			key: 'sample_rule',
			label: '样品规则',
			type: () => import('./tableCells/sampleCell.vue'),
			minWidth: '200',
			isShow: true,
		},
		{
			key: 'partner_rate',
			label: '提成比',
			isShow: that.isDrPartnerDataView && that.vuex_userInfo?.rate_status && that.$auth.hasPermi('system:goods:commissionPercentage'),
			type: ColumnTypes.serviceRateCell,
			minWidth: '100',
			helpNum: 1,
			helpDesc1: '仅展示推广给达人的提成比',
		},
		{
			key: 'promote_info',
			label: '推广信息',
			type: ColumnTypes.promotionCell,
			minWidth: '160',
			isShow: true,
		},
		{
			key: 'todoSource',
			label: '来源',
			type: ColumnTypes.sourceCell,
			minWidth: '200',
			isShow: true,
		},
		{
			key: 'activity',
			label: '活动信息',
			type: ColumnTypes.activityCell,
			minWidth: '270',
			showTag: true,
			isShow: true,
		},
		{
			key: 'claim_time',
			label: '认领时间',
			type: ColumnTypes.TextCell,
			minWidth: '270',
			showTag: true,
			isShow: true,
		},
		{
			key: 'author_num',
			label: '推广达人数',
			type: ColumnTypes.TextCell,
			minWidth: '120',
			showTag: true,
			isShow: that.$isPlatOr(that.platformId, ['Dy']),
			transform: row => {
				return {
					...row,
					author_num: row.product_sales?.author_num || 0,
				};
			},
		},
		{
			key: 'remark',
			label: '备注',
			type: ColumnTypes.TextCell,
			minWidth: '100',
			isShow: true,
		},
		{
			key: 'operations',
			label: '操作',
			type: ColumnTypes.ButtonsCell,
			minWidth: '100',
			fixed: 'right',
			align: 'right',
			isShow: true,
			moreType: 'ellipsis',
		},
	];

	return arr;
}

export default getColums;
